module.exports = __webpack_public_path__ + "static/img/package_7.d894792.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/package_7.jpg
// module id = Y9Ye
// module chunks = 1